import { Component, ElementRef, input, viewChild, AfterViewInit, output } from '@angular/core';
import { LoadingComponent } from '@app2/shared/components/loading/loading.component';

@Component({
  selector: 'sens-recycler-view',
  imports: [
    LoadingComponent,
  ],
  templateUrl: './recycler-view.component.html',
})
export class RecyclerViewComponent implements AfterViewInit {
  private feedEndTarget = viewChild.required<ElementRef>('feedEndTarget');

  isLoading = input.required<boolean>();

  isIntersecting = output<boolean>();

  public ngAfterViewInit() {

    if (!this.feedEndTarget().nativeElement) return;
    // Настраиваем Intersection Observer с порогом видимости 50%
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isIntersecting.emit(entry.isIntersecting);
      });
    }, {
      root: null,
      rootMargin: '0px 0px 1000px 0px',
      threshold: 0,
    });

    // Начинаем наблюдение за целевым элементом
    observer.observe(this.feedEndTarget().nativeElement);
  }
}
